import React from "react";
import { Line } from "react-chartjs-2";
import {
  CategoryScale,
  Chart,
  Legend,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
} from "chart.js/auto";

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "bottom" as const,
    },
  },
  title: {
    display: true,
    text: 'Line Chart',
  },
};

const LineChart = ({ chartData }: any) => {
  return <Line options={options} data={chartData} />;
};

export default LineChart;
